import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'

export function getName(){
  return 'archive/tag'
}

var markersByTag

export function getTableColumns(o,item){

  var markers = markersByTag[item._id]

  if(markers){
    var totalMarkers = markers.length
  } else {
    var totalMarkers = 0
  }

  var columns = [
    {
      id: 'de',
      value: item.de,
      type: o.type.text,
      width: 200,
    },
    {
      id: 'en',
      value: item.en,
      type: o.type.text,
      width: 200,
    },
    {
      id: 'fr',
      value: item.fr,
      type: o.type.text,
      width: 200,
    },
    {
      id: 'ru',
      value: item.ru,
      type: o.type.text,
      width: 200,
    },
    {
      id: 'public',
      value: item.public,
      type: o.type.toggle,
      width: 60,
    },
    {
      id: 'markers',
      value: totalMarkers,
      type: o.type.number,
    },
    {
      id: 'type',
      value: item.type,
      type: o.type.text,
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
    },
  ]

  return columns

}

export function getTableData(o){

  markersByTag = _.groupBy(o.data.archive.markers,'tag')

  var data =
    _.map(

      o.data.archive.tags,

      function(item){

        var model = o.model.aTags
        var columns = model.getTableColumns(o,item)

        var click =
          function(e){
            o.edit.set(item,model)
          }

        return {
          columns: columns,
          click: click,
        }

      }
    )

  return data

}

export function getFormFields(o,item){

  if(!item){
    var item = {}
  }

  var init = {
    public: true,
  }

  var fields = [
    {
      id: 'de',
      value: item.de,
      type: 'text',
      edit: true,
    },
    {
      id: 'en',
      value: item.en,
      type: 'text',
      edit: true,
    },
    {
      id: 'fr',
      value: item.fr,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'ru',
      value: item.ru,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'public',
      value: item.public,
      type: 'toggle',
      edit: true,
      init: init.public,
    },
    {
      id: 'type',
      value: item.type,
      type: 'text',
      edit: true,
      optional: true,
    },
  ]

  return fields

}

export function insertForm(o,done){

  var model = o.model.aTags

  var d = function(item){
    div.remove()
    done(item)
  }

  var c = function(item){
    div.remove()
  }

  var div =
    $('<div>')
    .css({
      position: 'fixed',
      top: '402px',
      width: '400px',
      left: 0,
      bottom: 0,
    })
    .append(
      form(o,model,null,d,c)
    )

  o.edit.append(div)

}

export function remove(o,id,done){

  var data = o.data.archive.tags
  var collection = 'a_tags'

  var usedMarkers = _.find(
    o.data.archive.markers,
    function(marker){
      return _.includes(marker.tags,id)
    }
  )

  var usedRolls = _.find(
    o.data.rolls,
    function(roll){
      return _.includes(roll.tags,id)
    }
  )

  if(usedMarkers || usedRolls){
    alert('tag in use.')
    done('tag_in_use')
    return
  }

  documentRemove(o,data,id,collection,done)
}

export function insert(o,item,done){

  var data = o.data.archive.tags
  var collection = 'a_tags'

  item.user = o.store('email')
  item.date = new Date()

  documentInsert(o,data,item,collection,done)

}

export function update(o,id,changes,done){

  var data = o.data.archive.tags
  var collection = 'a_tags'

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/aTags/aTags.js